import { Guest } from '../ts/Guest';
import calculateTotalGuests from './calculateTotalGuests';

export default function calculateTakenSeats(guests: Guest[]): number {
  const arrivedGuests = guests.filter((guest) => guest.hasArrived);
  return calculateTotalGuests(arrivedGuests);
}
